import React from 'react';
import { ExtendedFooterBox } from '../ExtendedFooterBox/ExtendedFooterBox';
import { boxContent } from './BoxContent';
import { Desktop } from '../MediaQuery/index';

/* Components */
const ItalistInfoBoxes: React.ComponentType<{}> = () => {
  return (
    <>
      <Desktop>
        <div className="divider">
          <hr />
        </div>
      </Desktop>
      <div className="info-boxes-container">
        {boxContent.map(content => (
          <ExtendedFooterBox
            color="#F25C5E"
            mainContent={React.createElement(content.innerComponent)}
            padding="0 20px"
            title={React.createElement(content.title)}
          />
        ))}
      </div>
      <Desktop>
        <div className="divider">
          <hr />
        </div>
      </Desktop>
      <style jsx>
        {`
          .info-boxes-container {
            display: flex;
            width: 100%;
            max-width: 1280px;
            min-height: 258px;
            margin: 35px auto 25px;
          }

          @media (max-width: 1023px) {
            .info-boxes-container {
              flex-direction: column;
            }
          }

          @media (min-width: 1024px) {
            .info-boxes-container {
              flex-direction: row;
            }
          }

          .divider {
            display: block;
            width: 100%;
            max-width: 1280px;
            margin: 18px auto;
          }

          .divider > hr {
            width: 100%;
            border: solid 2px #eeeef0;
            margin: 0;
          }
        `}
      </style>
    </>
  );
};

export default ItalistInfoBoxes;
